export const SET_ERROR = '@@error/SET_ERROR';
export const NETWORK_ERROR_CODE = -1;
